import {ajax as ajaxrx} from "rxjs/observable/dom/ajax";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import {Observable} from "rxjs/Observable";
import {mergeMap} from "rxjs/operators";
import {UploadFileWrapper} from "../../request/UploadFileWrapper/UploadFileWrapper";
import {AuthRequest} from "../../request/AuthRequest/AuthRequest";

export class RequestWrapper {

  static setAuthHeaders = (headers, token) => {
    return {
      Authorization: token,
      ...headers,
    };
  }

  static get(url: string) {
    return ajaxrx.getJSON(process.env.PUBLIC_URL + url);
  }

  static secureGet(url: string, authData: AuthRequest, headers?: {}) {
    return this.getTokenJwt(authData)
      .pipe(mergeMap((tokenJwt: string) => {
        return ajaxrx.getJSON(process.env.PUBLIC_URL + url, this.setAuthHeaders(headers, tokenJwt));
      }));
  }

  static securePost(url: string, data: AuthRequest, headers?: {}) {
    return this.getTokenJwt(data)
      .pipe(mergeMap(
        (tokenJwt: string) => {
          delete data.auth;
          return ajaxrx.post(process.env.PUBLIC_URL + url, data, this.setAuthHeaders(headers, tokenJwt));
        },
      ));
  }

  static secureUpload(url: string, authData: AuthRequest, files: UploadFileWrapper[], headers?: {}) {
    return this.getTokenJwt(authData)
      .pipe(mergeMap(
        (tokenJwt: string) => {
          const fd = new FormData();
          files.forEach(file => {
            fd.append(file.id, file.soporte);
          });
          return ajaxrx.post(process.env.PUBLIC_URL + url, fd, this.setAuthHeaders(headers, tokenJwt));
        },
      ));
  }

  static getTokenJwt(authData: AuthRequest): any {
    return new Observable((observer) => {
      const jwt = sessionStorage.jwt;
      if (jwt) {
        observer.next(jwt);
        observer.complete();
      } else {
        const requestUrl = "/autorizacion/token/recaptcha/" + authData.auth.tokenRecaptcha;
        this.get(requestUrl).subscribe(response => {
          const token = String(response);
          observer.next(token);
          observer.complete();
        });
      }
    });
  }
}
